






















































import Vue from 'vue';
import YoutubeEmbedPlayer from '@/components/YoutubeEmbedPlayer.vue';
import { Button, Icon, HeroImage } from '@/components/ds';
import { getAssetPath } from '@/helpers/assets';
import i18n from '@/i18n';

export default Vue.extend({
  components: {
    HeroImage,
    Button,
    Icon,
    YoutubeEmbedPlayer,
  },
  props: {
    isEssay: {
      type: Boolean,
      required: true,
    },
    isSecondGraduation: {
      type: Boolean,
      required: true,
    },
    isTransfer: {
      type: Boolean,
      required: true,
    },
    userFirstName: {
      type: String,
      required: true,
    },
    showNotifyMeButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      videoActive: false,
      backgroundSrc: getAssetPath('img/BackgroundImage.svg'),
      maskUrl: getAssetPath('img/mask.svg'),
    };
  },
  computed: {
    videoPlaylistId(): string {
      return 'PLAUHBC6vI2D3U2COzRkk3oX1y9RF9oRcr';
    },
    imgSrc(): string {
      return getAssetPath('img/hero/pending.jpg');
    },
    title(): string {
      const name = this.userFirstName;

      if (this.isEssay) return i18n.t('result.pendingApproval.essayTitle', { name });

      if (this.isSecondGraduation)
        return i18n.t('result.pendingApproval.secondGraduationTitle', { name });

      if (this.isTransfer) return i18n.t('result.pendingApproval.transferTitle', { name });

      return '';
    },
  },
  methods: {
    goToBlog() {
      window.location.replace('https://descomplica.com.br/blog/');
    },
  },
});
